import React, { useState } from 'react';

export default function Ordering(props) {
  /*
    props = [
      { name = Prezzo,  meta_key = prezzo, order_by = meta_value, order = asc }
      { name = Anno,  meta_key = anno, order_by = meta_value, order = asc  }
      { name = Chilometraggio,  meta_key = chilometraggio, order_by = meta_value, order = asc }
      { name = Date,  order_by = date, order = asc }
    ]    
  */
  const handleChange = (e) => {
    let baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
    let query = location.search.substring(1);
    if (query) {
      query = JSON.parse('{"' + decodeURI(query)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') + '"}')
    } else {
      query = {};
    }
    const newQuery = JSON.parse(e.target.options[e.target.options.selectedIndex].getAttribute('params'));
    delete newQuery['name'];
    let search = jQuery.param({ ...query, ...newQuery });
    window.history.pushState({}, "", baseUrl + '?' + search);
    window.location.reload();
  }

  return (
    <div className="select">
      <select onChange={handleChange} defaultValue={(new URLSearchParams(window.location.search)).get('id')}>
        {props.options.map(option => {
          return (
            <option
              key={option.id}
              value={option.id}
              params={JSON.stringify(option)}>{option.name} {option.order == 'asc' ? 'crescente' : 'decrescente'}</option>
          )
        })}
      </select >
    </div >
  );
}
